import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockCta extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('BlockCta', ScrollItem__BlockCta);

export default ScrollItem__BlockCta;
